import { monitor_schematicService } from '../_services';

const state = { onRequest: false, monitor_schematic: []};

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        monitor_schematicService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  monitor_schematic: state => {
    return state.monitor_schematic
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.monitor_schematic = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.monitor_schematic = data;
    },
    clear_data(state) {
      state.onRequest = false;
      state.monitor_schematic = [];
    },
    error(state) {
        state.onRequest = false;
    },
};

export const monitor_schematics = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
